module.exports = __webpack_public_path__ + "static/img/13.e153a8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/13.png
// module id = 1BPp
// module chunks = 0